"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var errors_1 = require("./errors");
// eslint-disable-next-line no-unused-vars
var Partition_1 = require("./Partition");
var Xid = /** @class */ (function () {
    function Xid(system, service, partition, entityType, localId, versionId) {
        if (!system) {
            throw new errors_1.XidError('string must contain a system');
        }
        this.system = system;
        this.service = service || null;
        this.partition = partition || null;
        this.entityType = entityType || null;
        this.localId = localId || null;
        this.versionId = versionId || null;
    }
    Xid.parse = function (str) {
        var parts = str.split(':');
        if (parts[0] !== 'urn') {
            throw new errors_1.XidError('string must start with "urn:"');
        }
        // remove 'urn' prefix
        parts.shift();
        return new Xid(parts[0], parts[1], parts[2] ? Partition_1.Partition.parse(parts[2]) : null, parts[3], parts[4], parts[5]);
    };
    Xid.prototype.toString = function () {
        var str = "urn:" + this.system;
        if (this.service) {
            str += ":" + this.service;
        }
        if (this.partition) {
            str += ":" + this.partition;
        }
        if (this.entityType) {
            str += ":" + this.entityType;
        }
        if (this.localId) {
            str += ":" + this.localId;
        }
        if (this.versionId) {
            str += ":" + this.versionId;
        }
        return str;
    };
    return Xid;
}());
exports.Xid = Xid;
